import './NotFoundView.css'

import PageCode from '../../Components/PageCode/PageCode';

const NotFoundView = () => {
  return (
    <div className='not-found-view'>
      <PageCode title='404' status='404' subTitle='Siamo spicenti, la pagina che hai richiesto non esiste' />
    </div>
  );
};

export default NotFoundView;